import Excel from "exceljs";
import { saveAs } from "file-saver";
import { Chart } from "primereact/chart";
import html2canvas from "html2canvas";
import React, { useContext, useEffect, useRef, useState } from "react";

import PPAContext from "../../../../contexts/PPA/PPAContext";
import {
  existingPPASenarioList,
  CountryCurrencyList,
} from "../../../../utils/PPA/PPAMasterList";
import "../Style/PPAStyles.css";
import { pascalCase } from "../../../../utils/display";
import { MessageContext } from "../../../../context/MessageContext";
import SuccessModal from "../../../../components/SuccessModal";
import moment from "moment";

export default function ExistingPPAValuationResult(props) {
  const [showSuccessModal, setShowScuccessModal] = useState(false);
  const [QDisCountedCFChart, setQDisCountedCFChart] = useState({});
  const [UnDiscountedCFChart, setUnDiscountedCFChart] = useState({});
  const [benchmarkDiscountedChart, setBenchmarkDiscountedChart] = useState({});
  const [ChartOptions, setChartOptions] = useState({});
  const [ChartYear, setChartYear] = useState("All");
  const [ChartScenario, setChartScenario] = useState("All");
  const [currency, setCurrency] = useState("EUR");
  const [valuationYears, setValuationYears] = useState([]);
  const {
    resultData,
    SetActiveTabId,
    SetFormData,
    formData,
    downloadValuationReport,
    saveValuationDetails,
  } = useContext(PPAContext);
  const { ErrorToast } = useContext(MessageContext);

  const UnDiscountedChartRef = useRef(null);
  const QDisCountedChartRef = useRef(null);
  const benchmarkDiscountedChartRef = useRef(null);
  const resultDivRef = useRef(null);

  const basisOfCalibration =
    formData?.basisOfCalibration === "usd" ? "$/MWh" : "%";

  useEffect(() => {
    getCurrency();
    getValuationYears();
    configureGraphData("All", "All");
    console.log("data", formData);
  }, []);

  const navigateBack = () => {
    SetActiveTabId("3");
  };

  const getValuationYears = () => {
    const years = [];
    resultData?.timeSeries?.forEach((item) => {
      years.push(item.split("-")[0]);
    });
    setValuationYears([...new Set(years)]);
  };

  const getCurrency = () => {
    CountryCurrencyList.find((x) => {
      if (x.country == formData.ppaLocation) {
        setCurrency(x.currency);
      }
    });
  };

  const configureGraphData = (year, scenario) => {
    let graphData;
    if (year != "All") graphData = processGraphData(year);
    else graphData = processGraphData();

    const {
      labels,
      discountedCashFlowData,
      unDiscountedCashFlowData,
      discountedCashFlowDataWithHighTolerance,
      unDiscountedCashFlowDataWithHighTolerance,
      discountedCashFlowDataWithLowTolerance,
      unDiscountedCashFlowDataWithLowTolerance,
      benchmarkDiscountedCashflow,
    } = graphData;

    const documentStyle = getComputedStyle(document.documentElement);
    // const textColor = documentStyle.getPropertyValue("--text-color");
    const textColor = "rgba(196, 196, 205, 1)";
    // const textColorSecondary = documentStyle.getPropertyValue(
    //   "--text-color-secondary"
    // );
    const textColorSecondary = "rgba(196, 196, 205, 1)";
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    // const surfaceBorder = "rgba(196, 196, 205, 1)";

    const QDisCountedCFData = {
      labels: labels,
      datasets: [
        // {
        //   label: "High",
        //   backgroundColor: documentStyle.getPropertyValue("--blue-500"),
        //   borderColor: documentStyle.getPropertyValue("--blue-500"),
        //   data:
        //     scenario === "High" || scenario === "All"
        //       ? discountedCashFlowDataWithHighTolerance
        //       : null,
        // },
        {
          label: "Medium",
          // backgroundColor: documentStyle.getPropertyValue("--pink-500"),
          backgroundColor: "#6b51bc",
          // borderColor: documentStyle.getPropertyValue("--pink-500"),
          borderColor: "#6b51bc",
          data:
            scenario === "Medium" || scenario === "All"
              ? discountedCashFlowData
              : null,
        },
        // {
        //   label: "Low",
        //   backgroundColor: documentStyle.getPropertyValue("--orange-500"),
        //   borderColor: documentStyle.getPropertyValue("--orange-500"),
        //   data:
        //     scenario === "Low" || scenario === "All"
        //       ? discountedCashFlowDataWithLowTolerance
        //       : null,
        // },
      ],
    };

    const UnDiscountedCFData = {
      labels: labels,
      datasets: [
        // {
        //   label: "High",
        //   backgroundColor: documentStyle.getPropertyValue("--blue-500"),
        //   borderColor: documentStyle.getPropertyValue("--blue-500"),
        //   data:
        //     scenario === "High" || scenario === "All"
        //       ? unDiscountedCashFlowDataWithHighTolerance
        //       : null,
        // },
        {
          label: "Medium",
          // backgroundColor: documentStyle.getPropertyValue("--pink-500"),
          backgroundColor: "#6b51bc",
          // borderColor: documentStyle.getPropertyValue("--pink-500"),
          borderColor: "#6b51bc",
          data:
            scenario === "Medium" || scenario === "All"
              ? unDiscountedCashFlowData
              : null,
        },
        // {
        //   label: "Low",
        //   backgroundColor: documentStyle.getPropertyValue("--orange-500"),
        //   borderColor: documentStyle.getPropertyValue("--orange-500"),
        //   data:
        //     scenario === "Low" || scenario === "All"
        //       ? unDiscountedCashFlowDataWithLowTolerance
        //       : null,
        // },
      ],
    };

    const benchmarkDiscountedCFData = {
      labels: labels,
      datasets: [
        {
          label: "Custom",
          backgroundColor: documentStyle.getPropertyValue("--blue-500"),
          borderColor: documentStyle.getPropertyValue("--blue-500"),
          data:
            scenario === "Custom" || scenario === "All"
              ? discountedCashFlowData
              : null,
        },
        {
          label: "EY",
          backgroundColor: documentStyle.getPropertyValue("--pink-500"),
          borderColor: documentStyle.getPropertyValue("--pink-500"),
          data:
            scenario === "EY" || scenario === "All"
              ? benchmarkDiscountedCashflow
              : null,
        },
      ],
    };

    const options = {
      maintainAspectRatio: true,
      aspectRatio: 0.0,
      plugins: {
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            display: false,
            drawBorder: true,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: true,
          },
        },
      },
    };

    setQDisCountedCFChart(QDisCountedCFData);
    setUnDiscountedCFChart(UnDiscountedCFData);
    setBenchmarkDiscountedChart(benchmarkDiscountedCFData);

    setChartOptions(options);
  };

  const getFilteredGraphData = (data, yearFilter) => {
    let filteredData = data?.map((item) => {
      return {
        ...item,
        year: item?.timestamp?.split("-")[0],
      };
    });
    if (yearFilter) {
      filteredData = filteredData?.filter((item) => item.year === yearFilter);
    }
    return filteredData;
  };

  const processGraphData = (yearFilter = "") => {
    const labels = [];
    const discountedCashFlowData = [];
    const unDiscountedCashFlowData = [];
    const benchmarkDiscountedCashflow = [];

    const filteredDiscountedCashFlowData = getFilteredGraphData(
      resultData?.presentValueOfCashflow,
      yearFilter,
    );
    const filteredUnDiscountedCashFlowData = getFilteredGraphData(
      resultData?.cashflowVariance,
      yearFilter,
    );

    const filteredBenchmarkDiscountedCashflow = getFilteredGraphData(
      resultData?.benchmarkPresentValueOfCashflow,
      yearFilter,
    );

    filteredDiscountedCashFlowData?.forEach((data, index) => {
      labels.push(data?.timestamp);
      discountedCashFlowData.push(data?.cashflow);
      unDiscountedCashFlowData.push(
        filteredUnDiscountedCashFlowData?.[index]?.cashflow,
      );
      benchmarkDiscountedCashflow.push(
        filteredBenchmarkDiscountedCashflow?.[index]?.cashflow,
      );
    });

    return {
      labels,
      discountedCashFlowData,
      unDiscountedCashFlowData,
      benchmarkDiscountedCashflow,
    };
  };

  const exportResult = async () => {
    if (formData?.valuationClientType === "channel_2") {
      saveAsExcel("Valuation-Result");
    } else {
      saveAsExcel("Valuation-Result");

      const resultDiv = resultDivRef.current;
      const canvas = await html2canvas(resultDiv);
      const base64Img = canvas.toDataURL("image/png");
      downloadValuationReport({
        clientName: formData?.clientName,
        entityName: formData?.entityName,
        projectName: formData?.projectName,
        companyName: formData?.companyName,
        referenceDetails: formData?.referenceDetails,
        inceptionDate: formData?.contractStartDate,
        valuationDate: formData?.valuationDate,
        ppaPrice:
          formData.ppaPricing !== "custom"
            ? formData?.ppaPrice
            : resultData?.ppaPriceCurve?.[0]?.value,
        contractStartDate: formData?.contractStartDate,
        contractEndDate: formData?.contractEndDate,
        buyerPercentage:
          formData?.generationType === "total_asset_generation"
            ? formData?.counterPartyAllocation
            : 100,
        counterParty: formData?.counterParty,
        totalValuation: resultData?.totalValuation,
        benchmarkTotalValuationAtLow:
          formData?.valuationAtInception === "no"
            ? resultData?.performBenchmarkCalculations
              ? resultData?.benchmarkTotalValuationAtLow
              : resultData?.totalValuationAtLow
            : 0,
        benchmarkTotalValuationAtHigh:
          formData?.valuationAtInception === "no"
            ? resultData?.performBenchmarkCalculations
              ? resultData?.benchmarkTotalValuationAtHigh
              : resultData?.totalValuationAtHigh
            : 0,
        unbundlingApproach: pascalCase(formData?.unbundlingApproach, "_"),
        image: base64Img.replace("data:image/png;base64,", ""),
      });
    }
  };

  const saveAsExcel = async (workBookName) => {
    const workbook = new Excel.Workbook();

    try {
      const fileName = workBookName;

      // Disclaimer Worksheet
      generateDisclaimerSheet(workbook);

      // Dashboard Worksheet
      generateDashboardSheet(workbook);

      // Input Forecasts Worksheet
      generateInputForecastSheet(workbook);

      // Empty Calc sheet
      generateEmptyCalcSheet(workbook);

      // Unbundle Worksheet
      if (formData?.calculateUnbundlingFactor === "yes") {
        generateUnbundleSheet(workbook);
      }

      // CFD Worksheet
      generateCFDSheet(workbook);

      if (resultData?.performBenchmarkCalculations) {
        // EY CFD Worksheet
        generateCFDSheet(workbook, true);
      }

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();

      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
      ErrorToast(`Something Went Wrong!. Please Try Again`);
    }
  };

  const setSheetHeaders = (
    sheet,
    header = "",
    startSeries = [],
    endSeries = [],
    yearSeries = [],
  ) => {
    addBlankRows(sheet, 2);

    const row1 = sheet.getRow(1);
    row1.fill = {
      type: "pattern",
      pattern: "darkHorizontal",
      fgColor: { argb: "484747" },
      bgColor: { argb: "484747" },
    };
    const A1 = sheet.getCell("A1");
    A1.value = "";

    const row2 = sheet.getRow(2);
    row2.fill = {
      type: "pattern",
      pattern: "darkHorizontal",
      fgColor: { argb: "484747" },
      bgColor: { argb: "484747" },
    };
    row2.font = {
      name: "Arial",
      size: 16,
      color: { argb: "FFE600" },
      bold: true,
    };
    row2.border = {
      bottom: { style: "thick", color: { argb: "FFFFFF" } },
    };

    // Header
    const A2 = sheet.getCell("A2");
    A2.value = header;

    addBlankRows(sheet, 4);
    const remainingHeaderRows = sheet.getRows(3, 4);
    remainingHeaderRows.forEach((headerRow) => {
      headerRow.fill = {
        type: "pattern",
        pattern: "darkHorizontal",
        fgColor: { argb: "484747" },
        bgColor: { argb: "484747" },
      };
      headerRow.font = {
        color: { argb: "FFFFFF" },
        bold: true,
      };
      headerRow.alignment = {
        horizontal: "right",
      };
      headerRow.getCell(1).value = "";
    });

    const row3 = sheet.getRow(3);
    const row3Data = [
      "Ref",
      ...(endSeries.map((_timestamp, index) => index + 1) || []),
    ];
    addRowData(row3, row3Data, 7);

    const row4 = sheet.getRow(4);
    const row4Data = [
      "Start",
      ...startSeries?.map((timestamp) =>
        moment(timestamp, "YYYY-MM-DD").format("DD-MMM-YY"),
      ),
    ];
    addRowData(row4, row4Data, 7);

    const row5 = sheet.getRow(5);
    const row5Data = [
      "End",
      ...endSeries?.map((timestamp) =>
        moment(timestamp, "YYYY-MM-DD").format("DD-MMM-YY"),
      ),
    ];
    addRowData(row5, row5Data, 7);

    const row6 = sheet.getRow(6);
    const row6Data = [
      "Units",
      "#",
      "",
      "Year",
      ...yearSeries?.map((timestamp) => timestamp),
    ];
    addRowData(row6, row6Data, 4);
  };

  const setDataHeader = (sheet, header = ["", ""], level = 1) => {
    const row = sheet.addRow({});

    // row.height = 25;

    let fillColor = "808080";
    let fontSize = 12;
    let cell1Index = 1;
    let cell2Index = 2;
    let bold = true;
    let fontColor = "000000";

    if (level === 2) {
      fontSize = 10.5;
      fillColor = "dad6d6";
      cell1Index = 2;
      cell2Index = 3;
      fontColor = "6c6c6e";
    } else if (level === 3) {
      fontSize = 11;
      fillColor = "FFFFFF";
      cell1Index = 3;
      cell2Index = 4;
      bold = true;
    }

    row.font = {
      name: "Arial",
      size: fontSize,
      color: { argb: fontColor },
      bold,
    };

    row.fill = {
      type: "pattern",
      pattern: "darkHorizontal",
      fgColor: { argb: fillColor },
      bgColor: { argb: fillColor },
    };

    row.alignment = { vertical: "middle" };

    const cell1 = row.getCell(cell1Index);
    cell1.value = header[0];
    cell1.alignment = {
      horizontal: "right",
      vertical: "middle",
      wrapText: true,
    };

    const cell2 = row.getCell(cell2Index);
    cell2.value = header[1];
    cell2.alignment = {
      horizontal: "left",
      vertical: "middle",
    };
  };

  const setRowData = ({
    sheet,
    heading = "",
    data = [],
    key = "",
    unit = "",
    extraData = "",
    bold = false,
    topUnderline = false,
    bottomUnderline = false,
    singleValue = false,
    horizontalAlignment = "right",
    verticalAlignment = "middle",
  }) => {
    let rowData = ["", "", "", heading, unit, extraData, "", ""];

    if (!singleValue) {
      data.forEach((item) => {
        rowData.push(item?.[key]);
      });
    }

    const row = sheet.addRow(rowData);

    row.font = {
      name: "Arial",
      size: 11,
      color: { argb: "000000" },
      bold,
    };

    row.alignment = {
      horizontal: horizontalAlignment,
    };

    row.numFmt = "0.00";

    if (topUnderline || bottomUnderline) {
      let border = {};
      if (topUnderline) {
        border.top = {
          style: "thin",
          color: { argb: "000000" },
        };
      }

      if (bottomUnderline) {
        border.bottom = {
          style: "thin",
          color: { argb: "000000" },
        };
      }

      row.border = border;
    }
  };

  const setLowMedumHighRows = ({
    sheet,
    heading = "",
    data = [],
    unit = "",
    bold = false,
    underline = false,
  }) => {
    setRowData({
      sheet,
      heading,
      unit,
      data,
      key: "low",
      extraData: "Low",
      bold,
      underline,
    });
    setRowData({
      sheet,
      heading: "",
      unit,
      data,
      key: "value",
      extraData: "Medium",
      bold,
      underline,
    });
    setRowData({
      sheet,
      heading: "",
      unit,
      data,
      key: "high",
      extraData: "High",
      bold,
      underline,
    });
  };

  const addRowData = (row, data = [], blankColums = 0) => {
    let rowData = [];
    if (blankColums) {
      for (let i = 1; i <= blankColums; i++) {
        rowData.push("");
      }
    }

    rowData = [...rowData, ...data];

    row.values = rowData;
  };

  const generateEndOfSheetRow = (worksheet, startCell = "", endCell = "") => {
    if (startCell === "" && endCell === "") {
      addBlankRows(worksheet, 3);
      const row = worksheet.addRow({});
      row.font = {
        name: "Arial",
        size: 12,
        color: { argb: "FFE600" },
        bold: true,
      };
      row.fill = {
        type: "pattern",
        pattern: "darkHorizontal",
        fgColor: { argb: "808080" },
        bgColor: { argb: "808080" },
      };
      row.alignment = {
        vertical: "middle",
      };
      const cell = row.getCell(1);
      cell.value = "End of sheet";
    } else {
      worksheet.mergeCells(`${startCell}:${endCell}`);
      const cell = worksheet.getCell(startCell);
      cell.style = {
        font: {
          name: "Arial",
          size: 12,
          color: { argb: "FFE600" },
          bold: true,
        },
        fill: {
          type: "pattern",
          pattern: "darkHorizontal",
          fgColor: { argb: "808080" },
          bgColor: { argb: "808080" },
        },
        alignment: {
          vertical: "middle",
        },
      };
      cell.value = "End of sheet";
    }
  };

  const generateDisclaimerSheet = (workbook) => {
    const disclaimerWorkSheet = workbook.addWorksheet("Disclaimer", {
      views: [{ showGridLines: false }],
    });

    disclaimerWorkSheet.mergeCells("B9:L30");
    const B9 = disclaimerWorkSheet.getCell("B9");
    B9.border = {
      top: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
    };

    B9.value = `DISCLAIMER\r\n
      This Financial Model ('the Model') has been constructed for a specific purpose and is not intended for distribution to third parties. Third parties who obtains copies of the Model should be aware of the following.\r\n
      - the Model may not be suitable for purposes, other than the specific purpose for which it was designed, and the interests of third parties may not have been anticipated;\r\n
      - the Model was not intended for use by third parties and may not be designed so that it can be readily operated in a correct manner by such parties;\r\n
      - the Model may be development version and may not be complete, or in the event that the development of the Model has concluded, material events may have occurred since completion, which are not reflected in the Model;\r\n
      - the Model may not have been subject to independent testing and where it has been tested, this may not provide an appropriate degree of assurance for all possible uses of the Model.\r\n
      Accordingly, third party recipients of his Model use it entirely at their own risk and, in the absence of express weitten consent, no responsibility is taken or accepted for any losses which may result therefrom, including direct or indirect consequences of computer viruses.\r\n
      `;
    B9.alignment = { vertical: "top", wrapText: true };
    B9.font = {
      name: "Arial",
      size: 11,
    };
  };

  const generateDashboardSheet = (workbook) => {
    const dashboardWorkSheet = workbook.addWorksheet("Dashboard", {
      views: [{ showGridLines: false }],
    });

    // Header
    dashboardWorkSheet.mergeCells("A1:R2");
    const A1 = dashboardWorkSheet.getCell("A1");
    A1.value = "Dashboard";
    A1.style = {
      font: {
        name: "Arial",
        size: 16,
        color: { argb: "FFE600" },
        bold: true,
      },
      fill: {
        type: "pattern",
        pattern: "darkHorizontal",
        fgColor: { argb: "484747" },
        bgColor: { argb: "484747" },
      },
    };

    dashboardWorkSheet.mergeCells("A3:R6");
    const A3 = dashboardWorkSheet.getCell("A3");
    A3.fill = {
      type: "pattern",
      pattern: "darkHorizontal",
      fgColor: { argb: "484747" },
      bgColor: { argb: "484747" },
    };
    A3.border = {
      top: { style: "thick", color: { argb: "FFFFFF" } },
    };

    // Sub Header
    dashboardWorkSheet.mergeCells("A9:R9");
    const A9 = dashboardWorkSheet.getCell("A9");
    A9.style = {
      font: {
        name: "Arial",
        size: 12,
        color: { argb: "000000" },
        bold: true,
      },
      fill: {
        type: "pattern",
        pattern: "darkHorizontal",
        fgColor: { argb: "808080" },
        bgColor: { argb: "808080" },
      },
      alignment: {
        vertical: "middle",
      },
    };
    A9.value = "    1. Inputs and KPIs";

    dashboardWorkSheet.getRow(9).height = 25;

    dashboardWorkSheet.getColumn(3).width = 40;
    dashboardWorkSheet.getColumn(4).width = 30;

    const C11 = dashboardWorkSheet.getCell("C11");
    C11.value = "Scenario Input";
    C11.style = {
      font: {
        name: "Arial",
        size: 10,
        color: { argb: "FFFFFF" },
        bold: true,
      },
      fill: {
        type: "pattern",
        pattern: "darkHorizontal",
        fgColor: { argb: "000000" },
        bgColor: { argb: "000000" },
      },
      alignment: {
        vertical: "middle",
        horizontal: "left",
      },
    };

    const D11 = dashboardWorkSheet.getCell("D11");
    D11.value = "Value";
    D11.style = {
      font: {
        name: "Arial",
        size: 10,
        color: { argb: "FFFFFF" },
        bold: true,
      },
      fill: {
        type: "pattern",
        pattern: "darkHorizontal",
        fgColor: { argb: "000000" },
        bgColor: { argb: "000000" },
      },
      alignment: {
        vertical: "middle",
        horizontal: "right",
      },
    };

    let inputRows = [
      {
        input: "Valuation Date",
        value: formData?.valuationDate,
      },
      {
        input: "Valuation At Inception",
        value: pascalCase(formData?.valuationAtInception),
      },
      {
        input: `Calibration Adjustment (${basisOfCalibration})`,
        value: resultData?.calibrationAdjustment,
      },
      {
        input: `Performing Valuation As A `,
        value: pascalCase(formData?.valuationPerspective),
      },
      {
        input: "Model Start Date",
        value: formData?.modelStartDate,
      },
      {
        input: "Start Of Agreement",
        value: formData?.contractStartDate,
      },
      {
        input: "End Of Agreement",
        value: formData?.contractEndDate,
      },
      {
        input: "Forecast Periodicity",
        value: pascalCase(formData?.valuationFreequency),
      },
      {
        input: "Generation Type",
        value: pascalCase(formData?.generationType, "_"),
      },
    ];

    if (formData?.generationType === "total_asset_generation") {
      inputRows.push({
        input: "PPA Allocation to Counterparty (%)",
        value: Number(formData?.counterPartyAllocation),
      });
    }

    inputRows = [
      ...inputRows,
      {
        input: "PPA Pricing",
        value: pascalCase(formData?.ppaPricing, "_"),
      },
    ];

    if (formData?.ppaPricing !== "custom") {
      inputRows.push({
        input: "Bundled PPA price ($/MWh)",
        value: Number(formData?.ppaPrice),
      });
    }

    if (formData?.changingVolumeInPPA === "no") {
      inputRows.push({
        input: "Changing Volume In PPA",
        value: pascalCase(formData?.changingVolumeInPPA),
      });

      inputRows.push({
        input: "Annual PPA Volume Capacity (GWh)",
        value: Number(formData?.annualPPAVolumeCapacity),
      });
    }

    inputRows = [
      ...inputRows,
      {
        input: "Assumed RET Scheme End Date",
        value: formData?.RETSchemeEndDate,
      },
      {
        input: "Discounting Approach",
        value: pascalCase(formData?.discountingApproach, "_"),
      },
      {
        input: "Discounting Convention",
        value: pascalCase(formData?.discountingConvention, "_"),
      },
      {
        input: "Unbundling Approach",
        value: pascalCase(formData?.unbundlingApproach || "", "_"),
      },
    ];

    if (
      formData?.calculateUnbundlingFactor === "no" &&
      formData?.unbundlingApproach === "flat_unbundling"
    ) {
      inputRows.push({
        input: "Unbundling Factor (%)",
        value: Number(formData?.unbundlingFactor),
      });
    }

    // This loop is used to set the row height till the required level.
    // Setting row height while listing the output values is not working. So using this loop tp overcome that.
    for (let i = 1; i <= 100; i++) {
      inputRows.push({
        input: "",
        value: "",
      });
    }

    let inputCurrentRowIndex = 11;
    inputRows.forEach((inputRow) => {
      inputCurrentRowIndex += 1;
      dashboardWorkSheet.getRow(inputCurrentRowIndex).height = 20;
      const inputCell = dashboardWorkSheet.getCell(`C${inputCurrentRowIndex}`);
      inputCell.value = inputRow.input;
      inputCell.style = {
        font: {
          name: "Arial",
          size: 10,
        },
        alignment: {
          vertical: "middle",
          horizontal: "left",
        },
      };

      const valueCell = dashboardWorkSheet.getCell(`D${inputCurrentRowIndex}`);
      valueCell.numFmt = "0.00";
      valueCell.value = inputRow.value;
      valueCell.style = {
        font: {
          name: "Arial",
          size: 10,
        },
        alignment: {
          vertical: "middle",
          horizontal: "right",
        },
      };
    });

    dashboardWorkSheet.getColumn(7).width = 30;
    dashboardWorkSheet.getColumn(8).width = 15;

    let scenarioHeaders = [];
    let scenarios = {};
    let outputRows = [];

    if (formData?.valuationAtInception === "yes") {
      outputRows = [
        {
          output: "Calibration Adjustment",
          key: "calibration",
        },
      ];
      scenarioHeaders = [{ label: "Output", key: "calibration" }];
      scenarios["calibration"] = {
        calibration: resultData?.calibrationAdjustment,
        isNegative: resultData?.calibrationAdjustment < 0 ? true : false,
      };
    } else {
      outputRows = [
        {
          output: "NPV",
          key: "npv",
        },
        {
          output: "NPV per MWh",
          key: "npvPerMwh",
        },
      ];

      if (formData?.valuationClientType === "channel_1") {
        if (formData?.useBenchmarkData === "yes") {
          scenarioHeaders = [
            { label: "Output - EY Low", key: "eyLow" },
            { label: "Output - EY Medium", key: "eyMedium" },
            { label: "Output - EY High", key: "eyHigh" },
          ];
          scenarios["eyLow"] = {
            npv: resultData?.benchmarkTotalValuationAtLow
              ? resultData?.benchmarkTotalValuationAtLow?.toLocaleString("en")
              : resultData?.totalValuationAtLow?.toLocaleString("en"),
            npvPerMwh: resultData?.benchmarKValuationPerMWhLow
              ? resultData?.benchmarKValuationPerMWhLow
              : resultData?.valuationPerMWhLow,
            isNegative:
              resultData?.benchmarkTotalValuationAtLow < 0 ? true : false,
          };

          scenarios["eyMedium"] = {
            npv: resultData?.benchmarkTotalValuation
              ? resultData?.benchmarkTotalValuation?.toLocaleString("en")
              : resultData?.totalValuation?.toLocaleString("en"),
            npvPerMwh: resultData?.benchmarkValuationPerMWh
              ? resultData?.benchmarkValuationPerMWh
              : resultData?.valuationPerMWh,
            isNegative: resultData?.benchmarkTotalValuation < 0 ? true : false,
          };

          scenarios["eyHigh"] = {
            npv: resultData?.benchmarkTotalValuationAtHigh
              ? resultData?.benchmarkTotalValuationAtHigh?.toLocaleString("en")
              : resultData?.totalValuationAtHigh?.toLocaleString("en"),
            npvPerMwh: resultData?.benchmarKValuationPerMWhHigh
              ? resultData?.benchmarKValuationPerMWhHigh
              : resultData?.valuationPerMWhHigh,
            isNegative:
              resultData?.benchmarkTotalValuationAtHigh < 0 ? true : false,
          };
        }

        // If custom black market price has also been provided, then provide the low, medium, high valuation for that values as well.
        if (resultData?.useCustomBlackMarketPriceCurve) {
          scenarioHeaders = [
            ...scenarioHeaders,
            { label: "Output - Custom Low", key: "customLow" },
            { label: "Output - Custom Medium", key: "customMedium" },
            { label: "Output - Custom High", key: "customHigh" },
          ];

          scenarios["customLow"] = {
            npv: `${resultData?.totalValuationAtLow?.toLocaleString("en")}`,
            npvPerMwh: resultData?.valuationPerMWhLow,
            isNegative: resultData?.totalValuationAtLow < 0 ? true : false,
          };

          scenarios["customMedium"] = {
            npv: `${resultData?.totalValuation?.toLocaleString("en")}`,
            npvPerMwh: resultData?.valuationPerMWh,
            isNegative: resultData?.totalValuation < 0 ? true : false,
          };

          scenarios["customHigh"] = {
            npv: `${resultData?.totalValuationAtHigh?.toLocaleString("en")}`,
            npvPerMwh: resultData?.valuationPerMWhHigh,
            isNegative: resultData?.totalValuationAtHigh < 0 ? true : false,
          };
        }
      } else {
        if (resultData?.performBenchmarkCalculations) {
          scenarioHeaders = [{ label: "Output - EY", key: "eyMedium" }];
          scenarios["eyMedium"] = {
            npv: `${resultData?.benchmarkTotalValuation?.toLocaleString("en")}`,
            npvPerMwh: `${resultData?.benchmarkValuationPerMWh}`,
            isNegative: resultData?.benchmarkTotalValuation < 0 ? true : false,
          };

          scenarioHeaders.push({
            label: "Output - Custom",
            key: "customMedium",
          });
          scenarios["customMedium"] = {
            npv: `${resultData?.totalValuation?.toLocaleString("en")}`,
            npvPerMwh: `${resultData?.valuationPerMWh}`,
            isNegative: resultData?.totalValuation < 0 ? true : false,
          };
        } else {
          scenarioHeaders = [
            {
              label:
                formData?.useBenchmarkData === "no"
                  ? "Output - Custom"
                  : "Output - EY",
              key: "eyMedium",
            },
          ];
          scenarios["eyMedium"] = {
            npv: `${resultData?.totalValuation?.toLocaleString("en")}`,
            npvPerMwh: `${resultData?.valuationPerMWh}`,
            isNegative: resultData?.totalValuation < 0 ? true : false,
          };
        }
      }
    }

    let outputCurrentRowIndex = 11;

    scenarioHeaders.forEach((scenarioHeader) => {
      dashboardWorkSheet.getRow(outputCurrentRowIndex).height = 20;
      dashboardWorkSheet.getRow(outputCurrentRowIndex).numFmt = "0.00";
      const labelCell = dashboardWorkSheet.getCell(`G${outputCurrentRowIndex}`);
      labelCell.value = scenarioHeader.label;
      labelCell.style = {
        font: {
          name: "Arial",
          size: 10,
          color: { argb: "FFFFFF" },
          bold: true,
        },
        fill: {
          type: "pattern",
          pattern: "darkHorizontal",
          fgColor: { argb: "000000" },
          bgColor: { argb: "000000" },
        },
        alignment: {
          vertical: "middle",
          horizontal: "left",
        },
      };

      const inputValueCell = dashboardWorkSheet.getCell(
        `H${outputCurrentRowIndex}`,
      );
      inputValueCell.value =
        formData?.valuationAtInception === "no" ? currency : basisOfCalibration;
      inputValueCell.style = {
        font: {
          name: "Arial",
          size: 10,
          color: { argb: "FFFFFF" },
          bold: true,
        },
        fill: {
          type: "pattern",
          pattern: "darkHorizontal",
          fgColor: { argb: "000000" },
          bgColor: { argb: "000000" },
        },
        alignment: {
          vertical: "middle",
          horizontal: "right",
        },
      };

      outputRows.forEach((outputRow) => {
        outputCurrentRowIndex += 1;
        const inputCell = dashboardWorkSheet.getCell(
          `G${outputCurrentRowIndex}`,
        );
        inputCell.value = outputRow.output;
        inputCell.style = {
          font: {
            name: "Arial",
            size: 10,
          },
          alignment: {
            vertical: "middle",
            horizontal: "left",
          },
        };

        const outputValueCell = dashboardWorkSheet.getCell(
          `H${outputCurrentRowIndex}`,
        );
        outputValueCell.value =
          scenarios?.[scenarioHeader.key]?.[outputRow.key];
        outputValueCell.style = {
          font: {
            name: "Arial",
            size: 10,
            color: {
              argb: scenarios?.[scenarioHeader.key]?.isNegative
                ? "B9251C"
                : "000000",
            },
          },
          alignment: {
            vertical: "middle",
            horizontal: "right",
          },
        };
      });

      outputCurrentRowIndex += 2;
    });

    // End of sheet header
    generateEndOfSheetRow(dashboardWorkSheet, "A40", "R40");
  };

  const generateInputForecastSheet = (workbook) => {
    const inputForecastsWorkSheet = workbook.addWorksheet("Input Forecasts", {
      views: [{ showGridLines: false }],
    });

    inputForecastsWorkSheet.properties.defaultRowHeight = 25;
    inputForecastsWorkSheet.properties.defaultColWidth = 12;

    inputForecastsWorkSheet.getColumn(3).width = 17;
    inputForecastsWorkSheet.getColumn(4).width = 35;
    inputForecastsWorkSheet.getColumn(5).alignment = { horizontal: "right" };
    inputForecastsWorkSheet.getColumn(6).alignment = { horizontal: "right" };

    setSheetHeaders(
      inputForecastsWorkSheet,
      "Input Forecasts",
      resultData?.startingSeries,
      resultData?.timeSeries,
      resultData?.yearSeries,
    );

    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["1.", "Forcast summary"], 1);

    /**
     * Prices
     */
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["1.1", "Prices"], 2);

    // Black market price
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["Black market price", ""], 3);

    addBlankRows(inputForecastsWorkSheet, 1);

    if (formData?.valuationAtInception === "no") {
      if (formData?.calculateUnbundlingFactor === "yes") {
        setRowData({
          sheet: inputForecastsWorkSheet,
          heading: "Black market price at inception",
          data: resultData?.blackMarketPriceCurveAtInception,
          key: "value",
          unit: "$/MWh",
        });
      }

      // EY benchmark data
      if (formData?.useBenchmarkData === "yes") {
        if (formData?.valuationClientType === "channel_1") {
          setLowMedumHighRows({
            sheet: inputForecastsWorkSheet,
            heading: "EY Black market price at Valuation Date",
            data: resultData?.benchmarkBlackMarketPriceCurve,
            unit: "$/MWh",
          });
        } else {
          setRowData({
            sheet: inputForecastsWorkSheet,
            heading: "EY Black market price at Valuation Date",
            data: resultData?.benchmarkBlackMarketPriceCurve,
            key: "value",
            unit: "$/MWh",
          });
        }
      }

      // Check whether custom black market price has been provided
      if (resultData?.useCustomBlackMarketPriceCurve) {
        if (formData?.valuationClientType === "channel_1") {
          setLowMedumHighRows({
            sheet: inputForecastsWorkSheet,
            heading: "Black market price at Valuation Date",
            data: resultData?.blackMarketPriceCurve,
            unit: "$/MWh",
          });
        } else {
          setRowData({
            sheet: inputForecastsWorkSheet,
            heading: "Black market price at Valuation Date",
            data: resultData?.blackMarketPriceCurve,
            key: "value",
            unit: "$/MWh",
          });
        }
      }
    } else {
      if (formData?.useBenchmarkData === "yes") {
        setRowData({
          sheet: inputForecastsWorkSheet,
          heading: "EY Black market price at inception",
          data: resultData?.benchmarkBlackMarketPriceCurve,
          key: "value",
          unit: "$/MWh",
        });
      }

      // Check whether a custom black market price curve has been provided.
      if (resultData?.useCustomBlackMarketPriceCurve) {
        setRowData({
          sheet: inputForecastsWorkSheet,
          heading: "Black market price at inception",
          data: resultData?.blackMarketPriceCurve,
          key: "value",
          unit: "$/MWh",
        });
      }
    }

    // LGC price
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["LGC market price", ""], 3);

    if (formData?.valuationAtInception === "no") {
      if (formData?.calculateUnbundlingFactor === "yes") {
        setRowData({
          sheet: inputForecastsWorkSheet,
          heading: "LGC market price at Inception",
          data: resultData?.greenMarketPriceCurveAtInception,
          key: "value",
          unit: "$/MWh",
        });
      }
    } else {
      if (formData?.useBenchmarkData === "yes") {
        setRowData({
          sheet: inputForecastsWorkSheet,
          heading: "EY LGC market price at inception",
          data: resultData?.benchmarkGreenMarketPriceCurve,
          key: "value",
          unit: "$/MWh",
        });
      }

      // Check whether a custom black market price curve has been provided.
      if (resultData?.useCustomGreenMarketPriceCurve) {
        setRowData({
          sheet: inputForecastsWorkSheet,
          heading: "LGC market price at inception",
          data: resultData?.greenMarketPriceCurve,
          key: "value",
          unit: "$/MWh",
        });
      }
    }

    /**
     * Volume Generation
     */
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["1.2", "Generation"], 2);

    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(
      inputForecastsWorkSheet,
      ["Forecast proportional generation", ""],
      3,
    );

    // Volume at inception
    addBlankRows(inputForecastsWorkSheet, 1);
    if (
      formData?.valuationAtInception === "no" &&
      formData?.calculateUnbundlingFactor === "yes"
    ) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Net generation at Inception",
        data: resultData?.volumeCurveAtInception,
        key: "value",
        unit: "GWh",
      });
    }

    // Volume at valuation date
    if (formData?.changingVolumeInPPA === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Net generation at Valuation Date",
        data: resultData?.volumeCurve,
        key: "value",
        unit: "GWh",
      });
    }

    /**
     * Generation adjustments
     */
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(
      inputForecastsWorkSheet,
      ["1.3", "Generation adjustments"],
      2,
    );

    // MLF
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["MLF", ""], 3);

    addBlankRows(inputForecastsWorkSheet, 1);

    // MLF at inception
    if (
      formData?.valuationAtInception === "no" &&
      formData?.calculateUnbundlingFactor === "yes" &&
      formData?.mlfIncludedInVolumeAtInception === "no"
    ) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "MLF at Inception",
        data: resultData?.mlfCurveAtInception,
        key: "value",
        unit: "%",
      });
    }

    // MLF at valuation date
    if (formData?.useBenchmarkData === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "EY MLF at Valuation Date",
        data: resultData?.benchmarkMLFCurve,
        key: "value",
        unit: "%",
      });
    }

    if (resultData?.useCustomMLFCurve) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "MLF at Valuation Date",
        data: resultData?.mlfCurve,
        key: "value",
        unit: "%",
      });
    }

    // DLF
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["DLF", ""], 3);

    addBlankRows(inputForecastsWorkSheet, 1);

    // DLF at inception
    if (
      formData?.valuationAtInception === "no" &&
      formData?.calculateUnbundlingFactor === "yes" &&
      formData?.dlfIncludedInVolumeAtInception === "no"
    ) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "DLF at Inception",
        data: resultData?.dlfCurveAtInception,
        key: "value",
        unit: "%",
      });
    }

    // DLF at valuation date
    if (formData?.useBenchmarkData === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "EY DLF at Valuation Date",
        data: resultData?.benchmarkDLFCurve,
        key: "value",
        unit: "%",
      });
    }

    if (resultData?.useCustomDLFCurve) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "MLF at Valuation Date",
        data: resultData?.dlfCurve,
        key: "value",
        unit: "%",
      });
    }

    // Curtailment
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["Curtailment factor", ""], 3);

    addBlankRows(inputForecastsWorkSheet, 1);

    // Curtailment at inception
    if (
      formData?.valuationAtInception === "no" &&
      formData?.calculateUnbundlingFactor === "yes" &&
      formData?.curtailmentIncludedInVolumeAtInception === "no"
    ) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Curtailment factor at Inception",
        data: resultData?.curtailmentFactorAtInception,
        key: "value",
        unit: "%",
      });
    }

    // Curtailment at valuation date
    if (formData?.useBenchmarkData === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "EY Curtailment factor at Valuation Date",
        data: resultData?.benchmarkCurtailmentFactor,
        key: "value",
        unit: "%",
      });
    }

    if (resultData?.useCustomCurtailmentFactor) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Curtailment factor at Valuation Date",
        data: resultData?.curtailmentFactor,
        key: "value",
        unit: "%",
      });
    }

    /**
     * Escalation factors
     */
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["1.4", "Escalation factors"], 2);

    if (formData?.ppaPricing !== "fix") {
      // PPA escalation factor
      addBlankRows(inputForecastsWorkSheet, 1);
      setDataHeader(inputForecastsWorkSheet, ["PPA escalation factor", ""], 3);

      addBlankRows(inputForecastsWorkSheet, 1);
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "PPA escalation factor at Valuation Date",
        data: resultData?.ppaEscalationCurve,
        key: "value",
        unit: "#",
      });
    }

    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(
      inputForecastsWorkSheet,
      ["Market escalaction factor", ""],
      3,
    );

    addBlankRows(inputForecastsWorkSheet, 1);
    if (formData?.useBenchmarkData === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "EY Market escalation factor at Valuation Date",
        data: resultData?.benchmarkInflationCurve,
        key: "value",
        unit: "#",
      });
    }

    if (resultData?.useCustomInflationCurve) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Market escalation factor at Valuation Date",
        data: resultData?.inflationCurve,
        key: "value",
        unit: "#",
      });
    }

    /**
     * Risk factors
     */
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["1.5", "Risk factors"], 2);

    // Risk-free rate
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(inputForecastsWorkSheet, ["Risk-free rate", ""], 3);

    addBlankRows(inputForecastsWorkSheet, 1);
    if (formData?.useBenchmarkData === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "EY Risk-free rate at Valuation Date",
        data: resultData?.benchmarkRiskFreeRateCurve,
        key: "value",
        unit: "%",
      });
    }

    if (resultData?.useCustomRiskFreeRateCurve) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Risk-free rate at Valuation Date",
        data: resultData?.riskFreeRateCurve,
        key: "value",
        unit: "%",
      });
    }

    // Asset credit risk adjustment
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(
      inputForecastsWorkSheet,
      ["Asset credit risk adjustment", ""],
      3,
    );

    addBlankRows(inputForecastsWorkSheet, 1);
    if (formData?.useBenchmarkData === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "EY Asset credit risk adjustment at Valuation Date",
        data: resultData?.benchmarkAssetCreditRiskAdjustmentCurve,
        key: "value",
        unit: "%",
      });
    }

    if (resultData?.useCustomAssetCreditRiskAdjustmentCurve) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Asset credit risk adjustment at Valuation Date",
        data: resultData?.assetCreditRiskAdjustmentCurve,
        key: "value",
        unit: "%",
      });
    }

    // Liability credit risk adjustment
    addBlankRows(inputForecastsWorkSheet, 1);
    setDataHeader(
      inputForecastsWorkSheet,
      ["Liability credit risk adjustment", ""],
      3,
    );

    addBlankRows(inputForecastsWorkSheet, 1);
    if (formData?.useBenchmarkData === "yes") {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "EY Liability credit risk adjustment at Valuation Date",
        data: resultData?.benchmarkLiabilityCreditRiskAdjustmentCurve,
        key: "value",
        unit: "%",
      });
    }

    if (resultData?.useCustomLiabilityCreditRiskAdjustmentCurve) {
      setRowData({
        sheet: inputForecastsWorkSheet,
        heading: "Liability credit risk adjustment at Valuation Date",
        data: resultData?.liabilityCreditRiskAdjustmentCurve,
        key: "value",
        unit: "%",
      });
    }

    generateEndOfSheetRow(inputForecastsWorkSheet);
  };

  const generateUnbundleSheet = (workbook) => {
    const unbundleWorkSheet = workbook.addWorksheet("c.Unbundle", {
      views: [{ showGridLines: false }],
    });

    unbundleWorkSheet.properties.defaultRowHeight = 25;
    unbundleWorkSheet.properties.defaultColWidth = 12;

    unbundleWorkSheet.getColumn(3).width = 17;
    unbundleWorkSheet.getColumn(4).width = 35;
    unbundleWorkSheet.getColumn(5).alignment = { horizontal: "right" };
    unbundleWorkSheet.getColumn(6).alignment = { horizontal: "right" };

    setSheetHeaders(
      unbundleWorkSheet,
      "c.Unbundle",
      resultData?.unbundlingStartingSeries,
      resultData?.unbundlingTimeSeries,
      resultData?.unbundlingYearSeries,
    );

    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["1.", "Market revenue"], 1);

    /**
     * Market price
     */
    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["1.1", "Market price"], 2);

    // Black market price
    addBlankRows(unbundleWorkSheet, 1);
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Inception black market price",
      data:
        formData?.valuationAtInception === "no"
          ? resultData?.blackMarketPriceCurveAtInception
          : resultData?.blackMarketPriceCurve,
      key: "value",
      unit: "$/MWh",
    });
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Inception LGC market price",
      data:
        formData?.valuationAtInception === "no"
          ? resultData?.greenMarketPriceCurveAtInception
          : resultData?.greenMarketPriceCurve,
      key: "value",
      unit: "$/MWh",
    });

    /**
     * Volumes
     */
    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["1.2", "Volumes"], 2);

    // Generation volume sent out
    addBlankRows(unbundleWorkSheet, 1);
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Generation volume sent out",
      data:
        formData?.valuationAtInception === "no"
          ? resultData?.volumeCurveAtInception
          : resultData?.volumeCurve,
      key: "value",
      unit: "GWh",
    });
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Total generation applicable to LGCs",
      data: resultData?.unbundlingVolumeAfterMlfDlfAndCurtailment,
      key: "volume",
      unit: "GWh",
      bold: true,
      topUnderline: true,
    });

    /**
     * Revenues
     */
    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["1.3", "Revenues"], 2);

    // LGC active flag
    addBlankRows(unbundleWorkSheet, 1);
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Generation volume sent out",
      data: resultData?.LGCActiveFlag,
      key: "activeFlag",
      unit: "#",
    });

    addBlankRows(unbundleWorkSheet, 1);
    // Black market revenue
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Black market revenue",
      data: resultData?.blackMarketRevenue,
      key: "revenue",
      unit: "$000",
    });

    // Green market revenue
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Black market revenue",
      data: resultData?.greenMarketRevenue,
      key: "revenue",
      unit: "$000",
    });

    // Total market revenue
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Total market revenue",
      data: resultData?.totalMarketRevenue,
      key: "revenue",
      unit: "$000",
      bold: true,
      topUnderline: true,
    });

    /**
     * Average black proportion
     */
    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["2.", "Average black proportion"], 1);

    /**
     * Simple average
     */
    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["2.1", "Simple average"], 2);

    addBlankRows(unbundleWorkSheet, 1);
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Black proportion",
      data: resultData?.simpleAverageBlackProportion?.map((item) => ({
        ...item,
        blackProportion: item?.blackProportion * 100,
      })),
      key: "blackProportion",
      unit: "%",
    });
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Simple average black proportion",
      extraData: (resultData?.avgOfsimpleAverageBlackProportion || 0) * 100,
      key: "blackProportion",
      unit: "%",
      singleValue: true,
      bold: true,
      topUnderline: true,
      bottomUnderline: true,
    });

    /**
     * Weighted average
     */
    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["2.2", "Weighted average"], 2);

    addBlankRows(unbundleWorkSheet, 1);
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Weighted-average period counter",
      data: resultData?.weightedAveragePeriodCounter,
      key: "value",
      unit: "#",
    });
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Black proportion",
      data: resultData?.weightedAverageBlackProportion?.map((item) => ({
        ...item,
        blackProportion: item?.blackProportion * 100,
      })),
      key: "blackProportion",
      unit: "%",
    });
    setRowData({
      sheet: unbundleWorkSheet,
      heading: "Weighted-average black proportion",
      extraData: (resultData?.totalWeightedAverageBlackProportion || 0) * 100,
      key: "blackProportion",
      unit: "%",
      singleValue: true,
      bold: true,
      topUnderline: true,
      bottomUnderline: true,
    });

    /**
     * Unbundling output
     */
    addBlankRows(unbundleWorkSheet, 1);
    setDataHeader(unbundleWorkSheet, ["2.3", "Unbundling output"], 2);

    addBlankRows(unbundleWorkSheet, 1);
    setRowData({
      sheet: unbundleWorkSheet,
      heading: pascalCase(formData?.unbundlingApproach, "_"),
      data: resultData?.unbundlingFactor?.map((item) => ({
        ...item,
        factor: item?.factor * 100,
      })),
      key: "factor",
      unit: "%",
      bold: true,
      topUnderline: true,
      bottomUnderline: true,
    });

    generateEndOfSheetRow(unbundleWorkSheet);
  };

  const generateEmptyCalcSheet = (workbook) => {
    const calcWorkSheet = workbook.addWorksheet("Calc>>", {
      views: [{ showGridLines: false }],
    });

    const row = calcWorkSheet.addRow([
      "This sheet has intentionally been left blank",
    ]);
    row.font = {
      name: "Arial",
      size: 11,
      color: { argb: "000000" },
    };
  };

  const generateCFDSheet = (workbook, benchmark = false) => {
    const cfdWorksheet = workbook.addWorksheet(
      benchmark ? "c.CFD - EY" : "c.CFD",
      {
        views: [{ showGridLines: false }],
      },
    );

    cfdWorksheet.properties.defaultRowHeight = 25;
    cfdWorksheet.properties.defaultColWidth = 12;

    cfdWorksheet.getColumn(3).width = 17;
    cfdWorksheet.getColumn(4).width = 35;
    cfdWorksheet.getColumn(5).width = 17;
    cfdWorksheet.getColumn(6).width = 17;
    cfdWorksheet.getColumn(5).alignment = { horizontal: "right" };
    cfdWorksheet.getColumn(6).alignment = { horizontal: "right" };

    setSheetHeaders(
      cfdWorksheet,
      benchmark ? "c.CFD - EY" : "c.CFD",
      resultData?.startingSeries,
      resultData?.timeSeries,
      resultData?.yearSeries,
    );

    /**
     * Undiscounted cashflows
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["1.", "Undiscounted cashflows"], 1);

    /**
     * Prices
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["1.1", "Prices"], 2);

    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["PPA price", ""], 3);

    // Applied PPA Price
    setRowData({
      sheet: cfdWorksheet,
      heading: "Unbundling factor",
      data: resultData?.unbundlingFactor?.map((item) => ({
        ...item,
        factor: item?.factor * 100,
      })),
      key: "factor",
      unit: "%",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "PPA price",
      data: resultData?.ppaPriceCurve,
      key: "value",
      unit: "$/MWh",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "PPA escalation factor",
      data: resultData?.ppaEscalationCurve,
      key: "value",
      unit: "#",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Applied PPA price",
      data: resultData?.appliedPPAPrice,
      key: "price",
      unit: "$/MWh",
      topUnderline: true,
      bold: true,
    });

    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["Black market price", ""], 3);

    // Applied black market price
    if (formData?.valuationClientType === "channel_1") {
      setLowMedumHighRows({
        sheet: cfdWorksheet,
        heading: "Black market price (100%)",
        data: benchmark
          ? resultData?.benchmarkBlackMarketPriceCurve
          : resultData?.useCustomBlackMarketPriceCurve
            ? resultData?.blackMarketPriceCurve
            : resultData?.benchmarkBlackMarketPriceCurve,
        unit: "$/MWh",
      });
    } else {
      setRowData({
        sheet: cfdWorksheet,
        heading: "Black market price (100%)",
        data: benchmark
          ? resultData?.benchmarkBlackMarketPriceCurve
          : resultData?.useCustomBlackMarketPriceCurve
            ? resultData?.blackMarketPriceCurve
            : resultData?.benchmarkBlackMarketPriceCurve,
        key: "value",
        unit: "$/MWh",
      });
    }
    setRowData({
      sheet: cfdWorksheet,
      heading: "Calibration adjustment",
      extraData: resultData?.calibrationAdjustment,
      key: "calibrationAdjustment",
      unit: "%",
      singleValue: true,
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Market escalation factor",
      data: benchmark
        ? resultData?.benchmarkInflationCurve
        : resultData?.useCustomInflationCurve
          ? resultData?.inflationCurve
          : resultData?.benchmarkInflationCurve,
      key: "value",
      unit: "#",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Applied black market price",
      data: benchmark
        ? resultData?.benchmarkAppliedBlackMarketPrice
        : resultData?.appliedBlackMarketPrice,
      key: "price",
      unit: "$/MWh",
      bold: true,
      topUnderline: true,
    });

    /**
     * Volumes
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["1.2", "Volumes"], 2);

    addBlankRows(cfdWorksheet, 1);
    if (formData?.generationType === "total_asset_generation") {
      setRowData({
        sheet: cfdWorksheet,
        heading: "PPA allocation to buyer",
        extraData: formData?.counterPartyAllocation,
        key: "counterPartyAllocation",
        unit: "%",
        singleValue: true,
      });
    }
    setRowData({
      sheet: cfdWorksheet,
      heading: "Portion of period",
      data: resultData?.portionOfPeriods,
      key: "stubPeriod",
      unit: "#",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Selected MW forecast",
      data: resultData?.volumeCurve,
      key: "value",
      unit: "GWh",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "MLF included in volume",
      extraData: pascalCase(formData?.mlfIncludedInVolume),
      key: "mlfIncludedInVolume",
      unit: "#",
      singleValue: true,
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "DLF included in volume",
      extraData: pascalCase(formData?.dlfIncludedInVolume),
      key: "dlfIncludedInVolume",
      unit: "#",
      singleValue: true,
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Curtailment included in volume",
      extraData: pascalCase(formData?.curtailmentIncludedInVolume),
      key: "curtailmentIncludedInVolume",
      unit: "#",
      singleValue: true,
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Total generation at node",
      data: resultData?.totalGenerationAtNodePerTimestamp,
      key: "volume",
      unit: "GWh/period",
      bold: true,
      topUnderline: true,
    });

    addBlankRows(cfdWorksheet, 1);
    setRowData({
      sheet: cfdWorksheet,
      heading: "Total volume",
      extraData: resultData?.totalGenerationAtNode,
      key: "totalGenerationAtNode",
      unit: "GWh",
      bold: true,
      topUnderline: true,
      bottomUnderline: true,
      singleValue: true,
    });

    /**
     * Cashflows
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["1.3", "Cashflows"], 2);

    addBlankRows(cfdWorksheet, 1);
    setRowData({
      sheet: cfdWorksheet,
      heading: "Revenue fixed",
      data: benchmark
        ? resultData?.benchmarkRevenuePPA
        : resultData?.revenuePPA,
      key: "revenue",
      unit: "$000",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Revenue floating",
      data: benchmark
        ? resultData?.benchmarkRevenueSpotMarket
        : resultData?.revenueSpotMarket,
      key: "revenue",
      unit: "$000",
    });
    if (formData?.ppaLocation === "United Kingdom") {
      setRowData({
        sheet: cfdWorksheet,
        heading: "Market escalation factor",
        data: benchmark
          ? resultData?.benchmarkInflationCurve
          : resultData?.useCustomInflationCurve
            ? resultData?.inflationCurve
            : resultData?.benchmarkInflationCurve,
        key: "value",
        unit: "#",
      });
    }
    setRowData({
      sheet: cfdWorksheet,
      heading: "Cash flow (variance)",
      data: benchmark
        ? resultData?.benchmarkCashflowVariance
        : resultData?.cashflowVariance,
      key: "cashflow",
      unit: "$000",
      bold: true,
      topUnderline: true,
      bottomUnderline: true,
    });

    addBlankRows(cfdWorksheet, 1);
    setRowData({
      sheet: cfdWorksheet,
      heading: "Total cash flow (variance)",
      extraData: benchmark
        ? resultData?.benchmarkTotalCashflowVariance
        : resultData?.totalCashflowVariance,
      key: "totalCashflowVariance",
      unit: "$000",
      bold: true,
      topUnderline: true,
      bottomUnderline: true,
      singleValue: true,
    });

    /**
     * Discounting
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["2.", "Discounting"], 1);

    /**
     * Net asset present value factor
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["2.1", "Net asset present value factor"], 2);

    addBlankRows(cfdWorksheet, 1);
    setRowData({
      sheet: cfdWorksheet,
      heading: "Valuation Date",
      extraData: "",
      key: "valuationDate",
      unit: formData?.valuationDate,
      bold: true,
      singleValue: true,
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Period factor",
      data: resultData?.periodFactor,
      key: "factor",
      unit: "#",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Risk-free rate",
      data: benchmark
        ? resultData?.benchmarkRiskFreeRateCurve
        : resultData?.useCustomRiskFreeRateCurve
          ? resultData?.riskFreeRateCurve
          : resultData?.benchmarkRiskFreeRateCurve,
      key: "value",
      unit: "%",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Asset credit risk adjustment",
      data: benchmark
        ? resultData?.benchmarkAssetCreditRiskAdjustmentCurve
        : resultData?.useCustomAssetCreditRiskAdjustmentCurve
          ? resultData?.assetCreditRiskAdjustmentCurve
          : resultData?.benchmarkAssetCreditRiskAdjustmentCurve,
      key: "value",
      unit: "%",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Net asset present value factor",
      data: benchmark
        ? resultData?.benchmarkNetAssetPresentValueFactor
        : resultData?.netAssetPresentValueFactor,
      key: "factor",
      unit: "Factor",
      bold: true,
      topUnderline: true,
    });

    /**
     * Net liability present value factor
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(
      cfdWorksheet,
      ["2.2", "Net liability present value factor"],
      2,
    );

    addBlankRows(cfdWorksheet, 1);
    setRowData({
      sheet: cfdWorksheet,
      heading: "Valuation Date",
      extraData: "",
      key: "valuationDate",
      unit: formData?.valuationDate,
      bold: true,
      singleValue: true,
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Period factor",
      data: resultData?.periodFactor,
      key: "factor",
      unit: "#",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Risk-free rate",
      data: benchmark
        ? resultData?.benchmarkRiskFreeRateCurve
        : resultData?.useCustomRiskFreeRateCurve
          ? resultData?.riskFreeRateCurve
          : resultData?.benchmarkRiskFreeRateCurve,
      key: "value",
      unit: "%",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Liability credit risk adjustment",
      data: benchmark
        ? resultData?.benchmarkLiabilityCreditRiskAdjustmentCurve
        : resultData?.useCustomLiabilityCreditRiskAdjustmentCurve
          ? resultData?.liabilityCreditRiskAdjustmentCurve
          : resultData?.benchmarkLiabilityCreditRiskAdjustmentCurve,
      key: "value",
      unit: "%",
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Net liability present value factor",
      data: benchmark
        ? resultData?.benchmarkNetLiabilityPresentValueFactor
        : resultData?.netLiabilityPresentValueFactor,
      key: "factor",
      unit: "Factor",
      bold: true,
      topUnderline: true,
    });

    /**
     * Selected net present value factor
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(
      cfdWorksheet,
      ["2.3", "Selected net present value factor"],
      2,
    );

    addBlankRows(cfdWorksheet, 1);
    setRowData({
      sheet: cfdWorksheet,
      heading: "Discounting approach",
      extraData: "",
      key: "discountingApproach",
      unit: formData?.discountingApproach,
      bold: true,
      singleValue: true,
    });
    setRowData({
      sheet: cfdWorksheet,
      heading: "Selected present value factor",
      data: benchmark
        ? resultData?.benchmarkExcessPresentValueFactor
        : resultData?.excessPresentValueFactor,
      key: "factor",
      unit: "Factor",
      bold: true,
      topUnderline: true,
    });

    /**
     * Discounted cash flow
     */
    addBlankRows(cfdWorksheet, 1);
    setDataHeader(cfdWorksheet, ["2.4", "Discounted cash flow"], 2);

    setRowData({
      sheet: cfdWorksheet,
      heading: "Present value of cash flows",
      data: benchmark
        ? resultData?.benchmarkPresentValueOfCashflow
        : resultData?.presentValueOfCashflow,
      key: "cashflow",
      unit: "$000",
      bold: true,
      topUnderline: true,
    });

    addBlankRows(cfdWorksheet, 1);
    if (formData?.valuationClientType === "channel_1") {
      setRowData({
        sheet: cfdWorksheet,
        heading: "Net present value - Low",
        extraData: benchmark
          ? resultData?.benchmarkTotalValuationAtLow
          : resultData?.totalValuationAtLow,
        key: "totalValuationAtLow",
        unit: "$000",
        bold: true,
        topUnderline: true,
        bottomUnderline: true,
      });
      setRowData({
        sheet: cfdWorksheet,
        heading: "Net present value - Medium",
        extraData: benchmark
          ? resultData?.benchmarkTotalValuation
          : resultData?.totalValuation,
        key: "totalValuation",
        unit: "$000",
        bold: true,
        topUnderline: true,
        bottomUnderline: true,
      });
      setRowData({
        sheet: cfdWorksheet,
        heading: "Net present value - High",
        extraData: benchmark
          ? resultData?.benchmarkTotalValuationAtHigh
          : resultData?.totalValuationAtHigh,
        key: "totalValuationAtHigh",
        unit: "$000",
        bold: true,
        topUnderline: true,
        bottomUnderline: true,
      });
    } else {
      setRowData({
        sheet: cfdWorksheet,
        heading: "Net present value",
        extraData: benchmark
          ? resultData?.benchmarkTotalValuation
          : resultData?.totalValuation,
        key: "totalValuation",
        unit: "$000",
        bold: true,
        topUnderline: true,
        bottomUnderline: true,
      });
    }

    generateEndOfSheetRow(cfdWorksheet);
  };

  const newPPACalculation = () => {
    SetFormData({});
    SetActiveTabId("1");
  };

  const hideSuccesModal = (showModal) => {
    setShowScuccessModal(showModal);
    newPPACalculation();
  };

  const saveValuation = async () => {
    const response = await saveValuationDetails();
    if (response.status === "success") {
      setShowScuccessModal(true);
    } else {
      console.log("Failed *****", response);
      ErrorToast(`Failed to save the valuation details. Please try again.`);
    }
  };

  const addBlankRows = (worksheet, count = 3) => {
    for (let i = 0; i < count; i++) {
      worksheet.addRow({});
    }
  };

  const handleYearChange = ({ target }) => {
    configureGraphData(target.value, ChartScenario);
    setChartYear(target.value);
  };

  const handleScenarioChange = ({ target }) => {
    configureGraphData(ChartYear, target.value);
    setChartScenario(target.value);
  };

  return (
    <>
      <div className="ppa_result_container">
        {formData?.valuationAtInception === "no" && (
          <div className="result-selection-wrapper">
            <div className="admin__contract__form__group col-md-3">
              <label htmlFor="year" className="avf-label ">
                Year
              </label>
              <select
                className="admin__contract__input ppa_param_select"
                id="year"
                name="year"
                value={ChartYear}
                onChange={(e) => handleYearChange(e)}
              >
                <option id="-1" value="All" key="-1">
                  ALL
                </option>
                {valuationYears.map((year, index) => (
                  <option id={index} value={year} key={index}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="admin__contract__form__group col-md-3">
              <label htmlFor="scenario" className="avf-label ">
                Scenario
              </label>
              <select
                className="admin__contract__input ppa_param_select"
                id="scenario"
                name="scenario"
                value={ChartScenario}
                onChange={(e) => handleScenarioChange(e)}
              >
                <option id="-1" value="All" key="-1">
                  ALL
                </option>
                {existingPPASenarioList.map((scenario, index) => (
                  <option id={index} value={scenario} key={index}>
                    {scenario}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
        {/* TABLE DATA */}
        <div className="ppa_result_wrapper">
          <div className="ppa_result_table_container" ref={resultDivRef}>
            <div>
              {formData?.valuationAtInception === "yes" && (
                <table className="ppa-result-calibration-table">
                  <thead>
                    <tr>
                      <th>Calibration Adjustment</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Value</td>
                      <td>{resultData?.calibrationAdjustment}</td>
                    </tr>
                  </tbody>
                </table>
              )}

              {formData?.valuationAtInception === "no" &&
                formData?.valuationClientType === "channel_2" &&
                resultData?.totalValuation !== undefined && (
                  <table>
                    <thead>
                      <tr>
                        <th>
                          {!resultData?.benchmarkTotalValuation &&
                          resultData?.performBenchmarkCalculations === false &&
                          formData?.useBenchmarkData === "yes"
                            ? "EY"
                            : "Custom"}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>NPV</td>
                        <td>
                          {resultData?.totalValuation?.toLocaleString("en")}{" "}
                          {currency}
                        </td>
                      </tr>
                      <tr>
                        <td>NPV per MWh</td>
                        <td>
                          {resultData?.valuationPerMWh} {currency}/MWh
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}

              {formData?.valuationAtInception === "no" &&
                formData?.valuationClientType === "channel_1" &&
                formData?.useBenchmarkData === "yes" && (
                  <>
                    <table>
                      <thead>
                        <tr>
                          <th>EY - Low</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>NPV</td>
                          <td>
                            {resultData?.benchmarkTotalValuationAtLow
                              ? resultData?.benchmarkTotalValuationAtLow?.toLocaleString(
                                  "en",
                                )
                              : resultData?.totalValuationAtLow?.toLocaleString(
                                  "en",
                                )}{" "}
                            {currency}
                          </td>
                        </tr>
                        <tr>
                          <td>NPV per MWh</td>
                          <td>
                            {resultData?.benchmarKValuationPerMWhLow
                              ? resultData?.benchmarKValuationPerMWhLow
                              : resultData?.valuationPerMWhLow}{" "}
                            {currency}
                            /MWh
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table>
                      <thead>
                        <tr>
                          <th>EY - Medium</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>NPV</td>
                          <td>
                            {resultData?.benchmarkTotalValuation
                              ? resultData?.benchmarkTotalValuation?.toLocaleString(
                                  "en",
                                )
                              : resultData?.totalValuation?.toLocaleString(
                                  "en",
                                )}{" "}
                            {currency}
                          </td>
                        </tr>
                        <tr>
                          <td>NPV per MWh</td>
                          <td>
                            {resultData?.benchmarkValuationPerMWh
                              ? resultData?.benchmarkValuationPerMWh
                              : resultData?.valuationPerMWh}{" "}
                            {currency}/MWh
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table>
                      <thead>
                        <tr>
                          <th>EY - High</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>NPV</td>
                          <td>
                            {resultData?.benchmarkTotalValuationAtHigh
                              ? resultData?.benchmarkTotalValuationAtHigh?.toLocaleString(
                                  "en",
                                )
                              : resultData?.totalValuationAtHigh?.toLocaleString(
                                  "en",
                                )}{" "}
                            {currency}
                          </td>
                        </tr>
                        <tr>
                          <td>NPV per MWh</td>
                          <td>
                            {resultData?.benchmarkValuationPerMWhHigh
                              ? resultData?.benchmarkValuationPerMWhHigh
                              : resultData?.valuationPerMWhHigh}{" "}
                            {currency}/MWh
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}

              {formData?.valuationAtInception === "no" &&
                formData?.valuationClientType === "channel_1" &&
                resultData?.useCustomBlackMarketPriceCurve && (
                  <>
                    <table>
                      <thead>
                        <tr>
                          <th>Custom - Low</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>NPV</td>
                          <td>
                            {resultData?.totalValuationAtLow?.toLocaleString(
                              "en",
                            )}{" "}
                            {currency}
                          </td>
                        </tr>
                        <tr>
                          <td>NPV per MWh</td>
                          <td>
                            {resultData?.valuationPerMWhLow} {currency}/MWh
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table>
                      <thead>
                        <tr>
                          <th>Custom - Medium</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>NPV</td>
                          <td>
                            {resultData?.totalValuation?.toLocaleString("en")}{" "}
                            {currency}
                          </td>
                        </tr>
                        <tr>
                          <td>NPV per MWh</td>
                          <td>
                            {resultData?.valuationPerMWh} {currency}/MWh
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table>
                      <thead>
                        <tr>
                          <th>Custom - High</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>NPV</td>
                          <td>
                            {resultData?.totalValuationAtHigh?.toLocaleString(
                              "en",
                            )}{" "}
                            {currency}
                          </td>
                        </tr>
                        <tr>
                          <td>NPV per MWh</td>
                          <td>
                            {resultData?.valuationPerMWhHigh} {currency}/MWh
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}

              {formData?.valuationAtInception === "no" &&
                formData?.valuationClientType === "channel_2" &&
                resultData?.performBenchmarkCalculations && (
                  <table>
                    <thead>
                      <tr>
                        <th>EY</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>NPV</td>
                        <td>
                          {resultData?.benchmarkTotalValuation.toLocaleString(
                            "en",
                          )}{" "}
                          {currency}
                        </td>
                      </tr>
                      <tr>
                        <td>NPV per MWh</td>
                        <td>
                          {resultData?.benchmarkValuationPerMWh} {currency}/MWh
                        </td>
                      </tr>
                      {/* <tr>
                                          <td>Break Even Price</td>
                                          <td>{resultData?.npvData?.low?.breakevenprice.toFixed(2)} {currency}/MWh</td>
                                      </tr> */}
                    </tbody>
                  </table>
                )}
            </div>
          </div>
          {formData?.valuationAtInception === "no" && (
            <div className="ppa_result_graphs_container">
              <div className="results_graphs">
                <div className="card mb-3">
                  <div className="graph-heading">
                    <h3>Undiscounted Cashflow</h3>
                  </div>
                  <Chart
                    type="bar"
                    ref={UnDiscountedChartRef}
                    data={UnDiscountedCFChart}
                    options={ChartOptions}
                  />
                </div>
                <div className="card mb-3">
                  <div className="graph-heading">
                    <h3>Cumulative Discounted Cashflow</h3>
                  </div>
                  <Chart
                    type="line"
                    ref={QDisCountedChartRef}
                    data={QDisCountedCFChart}
                    options={ChartOptions}
                  />
                </div>
                {resultData?.performBenchmarkCalculations && (
                  <div className="card mb-3">
                    <div className="graph-heading">
                      <h3>Discounted Cashflow - EY vs Custom</h3>
                    </div>
                    <Chart
                      type="bar"
                      ref={benchmarkDiscountedChartRef}
                      data={benchmarkDiscountedChart}
                      options={ChartOptions}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="ppa__result__options ">
          <button
            className="forward__option btn-secondary mr-2"
            onClick={navigateBack}
          >
            Back
          </button>
          <button
            className="forward__option btn-secondary mr-2"
            onClick={newPPACalculation}
          >
            New PPA
          </button>
          <button
            className="forward__option btn-primary mr-2"
            onClick={exportResult}
          >
            Generate Report
          </button>
          {!formData?.readOnly && (
            <button
              className="forward__option btn-primary"
              onClick={saveValuation}
            >
              Save
            </button>
          )}
        </div>
      </div>
      {showSuccessModal ? (
        <SuccessModal
          title="Valuation Details"
          message="Valuation details has been successfully saved."
          toggleModal={hideSuccesModal}
        />
      ) : null}
    </>
  );
}
